import { Component, Input, ElementRef, ChangeDetectorRef, AfterViewInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { PieChart } from 'chartist';
import { BehaviorSubject } from 'rxjs';


@Component({
    selector: 'app-pie-chart',
    templateUrl: 'pie.html',
    styleUrls: ['pie.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PieChartComponent implements AfterViewInit {
    private initialized = false;
    total: number;
    legends: BehaviorSubject<LegendItem[]> = new BehaviorSubject([]);

    @Input() loadingData: any;
    @Input() fontFamily: string;
    @Input() description: string;
    @Input() options: any = {
        donut: true,
        donutWidth: 17,
        showLabel: false
    };
    // https://www.materialui.co/colors
    @Input() color = '253,99,107';
    @Input() style = 'donutGradient1';
    @Input() id: string = 'donut-gradient-chart1';

    private _data: PieDataItem[];
    public get data(): PieDataItem[] {
        return this._data;
    }
    @Input()
    public set data(v: PieDataItem[]) {
        this._data = v;
        this.init();
    }


    constructor(private elementRef: ElementRef,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngAfterViewInit() {
        this.initialized = true;
        if (this.data) {
            this.init();
        }
    }

    private init() {
        if (!this.data || !this.data.length || !this.initialized) {
            return;
        }

        const value = this.data[0].value;
        const chartElement = (this.elementRef.nativeElement as HTMLElement).querySelector('.chart-container');
        const chart = new PieChart(chartElement, {
            series: [100]
        }, {
            labelInterpolationFnc: v => {
                return value;
            },
            donut: true,
            total: 100,
            donutWidth: 10,
        });


        const color = this.color;
        const style = this.style;
        chart.on('draw', (data) => {
            if (data.type === 'slice') {
                // Chartist 1.x uses stroke-based donuts (ct-slice-donut). Without fill:none
                // the SVG path defaults to fill="black", making the center appear solid black.
                // Apply the gradient as a stroke and clear the fill inline so CSS can't interfere.
                data.element.attr({
                    style: `fill: none; stroke: url(#${style}); stroke-width: 10px`
                });
            }
            if (data.type === 'label') {
                if (data.index === 0) {
                    data.element.attr({
                        dx: data.element.root().width() / 2,
                        dy: data.element.root().height() / 2,
                        'font-family': this.fontFamily
                    });
                } else {
                    data.element.remove();
                }
            }
        });
        chart.on('created', (data) => {
            const defs = data.svg.querySelector('defs') || data.svg.elem('defs');
            defs.elem('linearGradient', {
                id: style,
                x1: 0,
                y1: 1,
                x2: 0,
                y2: 0
            }).elem('stop', {
                offset: '0%',
                'stop-color': 'rgba(' + color + ', 1)'
            }).parent().elem('stop', {
                offset: '95%',
                'stop-color': 'rgba(' + color + ', 0.3)'
            });
            return defs;
        });

        this.loadingData = false;
        this.changeDetectorRef.detectChanges();
    }
}


export interface LegendItem {
    color: string;
    title: string;
    value: number;
    precent: number;
}

export interface PieDataItem {
    color: string;
    title: string;
    value: number;
}
